var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSymbolSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M11.375,1.75c-3.677,0-6.668,2.991-6.668,6.668c0,1.435,0.46,2.762,1.234,3.851L1.8,16.641 c-0.475,0.501-0.453,1.292,0.048,1.767c0.242,0.229,0.551,0.343,0.859,0.343c0.331,0,0.662-0.131,0.908-0.391l4.127-4.357 c1.046,0.683,2.293,1.084,3.633,1.084c3.677,0,6.668-2.991,6.668-6.668C18.043,4.741,15.052,1.75,11.375,1.75z M11.375,13.586 c-2.85,0-5.168-2.318-5.168-5.168c0-2.85,2.318-5.168,5.168-5.168c2.85,0,5.168,2.318,5.168,5.168 C16.543,11.268,14.225,13.586,11.375,13.586z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolSearch);
export default __webpack_public_path__ + "static/media/symbol-search.fca1c30c.svg";
export { ForwardRef as ReactComponent };